export default __webpack_public_path__ + "static/media/sort-none.02ffb44f.svg";